import { Suspense } from 'react';
import { Spin } from 'antd';
import { Navigate } from 'react-router-dom';
import { findPanel } from './registry';
import { PanelErrorBoundary } from './PanelErrorBoundary';
import { useAuth } from '../auth/AuthContext';
import { canSeePanel } from '../auth/panelAccess';

interface Props {
  panelId: string;
}

export function PanelHost({ panelId }: Props) {
  const { role } = useAuth();
  const panel = findPanel(panelId);
  if (!panel) {
    return <div>未注册的面板：{panelId}</div>;
  }
  // 无权访问的面板(如 maker 直链到 Quant 组的 grid-live):退回 section index,
  // 由 SectionIndex 按角色选第一个可见面板(不会死循环)。
  if (!canSeePanel(panel, role)) {
    return <Navigate to={`/${panel.topNav}`} replace />;
  }
  const Component = panel.component;
  if (!Component) {
    return <div>该入口为外部链接，无内嵌视图：{panelId}</div>;
  }
  return (
    <PanelErrorBoundary key={panelId}>
      <Suspense fallback={<Spin />}>
        <Component />
      </Suspense>
    </PanelErrorBoundary>
  );
}
